import { useNavigate } from "react-router";

import { tw } from "@/utils";

export const WrongAccess = () => {
  const navigate = useNavigate();

  return (
    <section className="flex w-full flex-col items-center justify-center">
      <div className="">잘못된 접근입니다.</div>
      <button
        className={tw(
          "mt-[30px] rounded-[12px] px-[16px] py-[6px]",
          "bg-main bg-gray-300 text-black hover:bg-gray-400"
        )}
        onClick={() => navigate("/")}
      >
        홈으로
      </button>
    </section>
  );
};
